import { ILabel, ILanguageRules } from "../Interfaces";
import { PluralOperands } from "../PluralOperands";

export class Rules implements ILanguageRules
{
    public getPlural(label: ILabel, count: number | string): string
    {
        const operands = new PluralOperands(count);
        if (operands.n == 1)
        {
            return label.one;
        }
        else if ((operands.e == 0 && operands.i != 0 && operands.i % 1000000 == 0 && operands.v == 0) || (operands.e < 0 && operands.e > 5))
        {
            return label.many;
        }
        else
        {
            return label.other;
        }
    }
}
